import { useSnackbar } from 'notistack';
import { useTranslation } from 'next-i18next';
import { extractErrorMessage } from '../utils/error.js';
import '../serverErrors-O6unZmFR.js';
import '../utils/logger.js';
import '../utils/logToSlack.js';
import '../utils/logToRelic.js';

// Shows an error using notistack
// message passed should be a translation key or iError object
const useShowError = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation('');
    const call = (message, props) => {
        let formattedMessage;
        if (typeof message === 'object') {
            formattedMessage = extractErrorMessage(message);
        }
        else {
            formattedMessage = message;
        }
        if (formattedMessage && snackbar.enqueueSnackbar) {
            snackbar.enqueueSnackbar(t(formattedMessage), {
                variant: 'error',
                className: 'error-ui',
                ...props,
            });
        }
    };
    return call;
};

export { useShowError as default };
//# sourceMappingURL=useShowError.js.map
